// eslint-disable-next-line no-unused-vars
import SubBubbleAgreementDiscountDTO from './subBubbleAgreementDiscountDTO'

export default class UpdateSubBubbleAgreementDTO {
  constructor({ id, startDateLocal, endDateLocal, discounts } = {}) {
    /**
     * @type {Number}
     */
    this.id = id
    /**
     * @type {Date}
     */
    this.startDateLocal = startDateLocal
    /**
     * @type {Date}
     */
    this.endDateLocal = endDateLocal
    /**
     * @type {SubBubbleAgreementDiscountDTO[]}
     */
    this.discounts = discounts
  }
}
